<header class="masthead">
  <div class="container h-100">
    <div class="row h-100 align-items-center">
      <div class="col-12 text-center">
        <h1 class="outline-title">Fintech</h1>
      </div>
    </div>
  </div>
</header>

<section class="modern-service-hero-section py-5">
  <div class="container px-5 my-5">
    <div class="row align-items-center">
      <div class="col-lg-7">
        <a class="service-detail-back" routerLink="/servicios">
          <i class="bi bi-arrow-left"></i>
          Servicios
        </a>
        <h1 class="modern-section-title mb-3">
          Soluciones fintech para el <span class="highlight-green">futuro financiero</span>
        </h1>
        <div class="section-underline"></div>
        <p class="lead text-light mb-4">
          Diseñamos e implementamos plataformas financieras digitales con seguridad, escalabilidad y experiencia de usuario.
        </p>
        <ul class="modern-checklist">
          <li><i class="bi bi-check-circle-fill"></i> Aplicaciones financieras nativas</li>
          <li><i class="bi bi-check-circle-fill"></i> Consultoría estratégica especializada</li>
          <li><i class="bi bi-check-circle-fill"></i> Ciberseguridad financiera avanzada</li>
        </ul>
      </div>
      <div class="col-lg-5 text-center">
        <app-service-orbit-visual iconClass="bi bi-bank"></app-service-orbit-visual>
      </div>
    </div>
  </div>
</section>

<!-- CARDS DE SERVICIOS -->
<section class="modern-service-cards-section py-5">
  <div class="container">
    <div class="row g-4">
      <div class="col-md-4 d-flex">
        <div class="modern-service-card glass-card w-100 text-center">
          <div class="icon-box mx-auto mb-3">
            <i class="fa fa-credit-card"></i>
          </div>
          <h4 class="modern-service-card-title">Pagos Digitales</h4>
          <p>Integramos pasarelas de pago seguras y eficientes para mejorar experiencia transaccional.</p>
        </div>
      </div>
      <div class="col-md-4 d-flex">
        <div class="modern-service-card glass-card w-100 text-center">
          <div class="icon-box mx-auto mb-3">
            <i class="bi bi-shield-lock"></i>
          </div>
          <h4 class="modern-service-card-title">Ciberseguridad</h4>
          <p>Protegemos activos y datos financieros con protocolos robustos y enfoque preventivo.</p>
        </div>
      </div>
      <div class="col-md-4 d-flex">
        <div class="modern-service-card glass-card w-100 text-center">
          <div class="icon-box mx-auto mb-3">
            <i class="bi bi-lightning-charge"></i>
          </div>
          <h4 class="modern-service-card-title">Innovación Digital</h4>
          <p>Creamos soluciones escalables adaptadas al ecosistema financiero nacional e internacional.</p>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- SECCIÓN POR QUÉ ELEGIRNOS -->
<section class="modern-service-why-section py-5">
  <div class="container px-5 my-5">
    <div class="row align-items-center">
      <div class="col-md-6">
        <h2 class="modern-section-title mb-3">
          ¿Por qué <span class="highlight-green">elegirnos?</span>
        </h2>
        <div class="section-underline"></div>
        <ul class="modern-checklist">
          <li><i class="bi bi-check-circle-fill"></i> Experiencia en sector financiero</li>
          <li><i class="bi bi-check-circle-fill"></i> Enfoque en seguridad y escalabilidad</li>
          <li><i class="bi bi-check-circle-fill"></i> Visión tecnológica aplicada a negocio</li>
        </ul>
      </div>
      <div class="col-md-6">
        <div class="glass-card p-4">
          <p class="mb-0 text-light">
            Transforma tu presencia en el mundo fintech con tecnología lista para escalar.
          </p>
        </div>
      </div>
    </div>
  </div>
</section>
